import { requests } from 'common/axios';
import {
    GetAllPreferredProvidersResponse,
    GetIpaNetworkMappingsDistinctTinsResponse,
    IPreferredStatusMapping,
} from 'components/ProviderData/IpaAdministration/atoms/Models';

export const BASE_URL = '/api/PreferredStatusMappingManager';

export const PreferredStatusApi = {
    searchPaginatedRecords: (queryParameters: string) =>
        requests.get<IPreferredStatusMapping[]>(`${BASE_URL}/GetIpaWebPreferredStatusPaginated?${queryParameters}`),

    createRecord: (data: IPreferredStatusMapping) => requests.post<IPreferredStatusMapping>(`${BASE_URL}`, { data }),

    updateRecord: (data: IPreferredStatusMapping) => requests.put<IPreferredStatusMapping>(`${BASE_URL}`, { data }),

    getTaxIdsByIpaCode: (ipaCode: string) =>
        requests.get<GetIpaNetworkMappingsDistinctTinsResponse>(`${BASE_URL}/DistinctTinNumbers?ipaCode=${ipaCode}`),

    getPreferredStatusCodes: () => requests.get<GetAllPreferredProvidersResponse>(`${BASE_URL}/AllPreferredStatus`),
};
